import "./common.css";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../components/common/style.css";
import "../../components/common/responsive.css";
// import './popupLogin.css'
import { useUser } from "../../contexts/userContext";
import "../../pages/login/loginPage.css";
import "../../components/common/style.css";
import "../../components/common/responsive.css";
import "../../pages/sell-now/popupLogin.css";
import { useApi } from "../../shared/api";
import { userLoginEvent } from '../../shared/events/login.event';

import { useSelector } from "react-redux";
import { selectUtmCampaign } from "../../redux/slices/utm";

const isInvalidPhoneNumber = (mobileNo: string) => {
  if (mobileNo.startsWith("0") && mobileNo.length == 10) {
    return true;
  }
  return false;
}

const formatMobileNumber = (mobileNo: string) => {
  if (mobileNo.length > 5) {
    return mobileNo.slice(0, 5) + " " + mobileNo.slice(5, 10);
  }
  return mobileNo;
}
export interface LoginProps {
  redirectUrl: boolean;
  setIsNavigation: (value: boolean) => void;
  utmQuery?: any;
  handleLogin: (isRedirect: boolean, userId: number, mobileNo: string) => void;
  isVisible?: boolean;
  focusTrigger?: number;
  handleLoginSuccess?: (bool: boolean) => void;
  initialMobileNo?: string;
  resetTrigger?: number;
}



export const Login = (
  { redirectUrl, setIsNavigation, utmQuery, handleLogin, isVisible = true, focusTrigger, handleLoginSuccess, initialMobileNo = "", resetTrigger = 0 }: LoginProps
) => {
  const formattedMobile = formatMobileNumber(initialMobileNo);
  const API = useApi();
  const navigate = useNavigate();
  const [mobileNo, setMobileNo] = useState(initialMobileNo ?? '');
  const [formattedMobileNo, setFormattedMobileNo] = useState(formattedMobile ?? '');
  const [showError, setShowError] = useState(false);
  const nameInputRef = useRef<HTMLInputElement>(null);
  const { city_pincode } = useUser();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const utm_query = useSelector(selectUtmCampaign)
  utmQuery = utmQuery || utm_query || "";

  useEffect(() => {
    if (!isVisible) return;

    // Aggressive focus strategy for iOS
    const attemptFocus = () => {
      if (nameInputRef.current) {
        nameInputRef.current.focus();
        // Try to force cursor to end
        // nameInputRef.current.setSelectionRange(
        //   nameInputRef.current.value.length,
        //   nameInputRef.current.value.length
        // );
      }
    };

    attemptFocus(); // Immediate attempt

    // Retry multiple times to catch state after transition/animation
    const intervalId = setInterval(attemptFocus, 100);

    // Stop retrying after 1 second
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 1000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [isVisible, focusTrigger]);

  useEffect(() => {
    if (initialMobileNo) {
      setMobileNo(initialMobileNo);
      setFormattedMobileNo(formattedMobile);
    }
  }, [initialMobileNo]);

  useEffect(() => {
    // Reset mobile number only when resetTrigger changes AND initialMobileNo is empty
    // This ensures we clear on modal close but not when switching to login from verifyOtp
    if (!initialMobileNo && resetTrigger > 0) {
      setMobileNo('');
      setFormattedMobileNo('');
      setShowError(false);
      setError(null);
    }
  }, [resetTrigger, initialMobileNo]);





  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, ""); // Allow only numbers
    const mobilenumber = e.target.value.replace(/\D/g, "");
    if (value.length > 5) {
      value = value.slice(0, 5) + " " + value.slice(5, 10);
    }
    e.target.value = value;

    setFormattedMobileNo(formatMobileNumber(mobilenumber));
    setMobileNo(mobilenumber);
    setShowError(mobilenumber.length > 0 && mobilenumber.length < 10);
    if (isInvalidPhoneNumber(mobilenumber)) {
      setError("Please enter a correct mobile number");
      // Clear error after 3 seconds
      return;
    }
    // Clear the error message when the user starts typing
    if (error) {
      setError(null);
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    e.target.focus()
    setError(null); // Clear error message on focus
  };

  const hanldeLogin = async (showPopup: boolean = false) => {

    setShowError(false);
    if (!mobileNo || mobileNo.trim() === "" || isInvalidPhoneNumber(mobileNo)) {
      setError("Please enter 10 digits mobile number");
      setTimeout(() => setError(null), 30000); // Clear error after 2 seconds
      return;
    }

    try {
      setLoading(true)
      const ref_code = sessionStorage.getItem("setReferralCode") || "";

      const loginData = {
        mobile_no: mobileNo,
        referral_code: ref_code,
        pincode: city_pincode as string,
      };

      const resLogin = await API.API_V1.auth.postLogin(loginData, utm_query);

      const resJson = resLogin.data;
      userLoginEvent(mobileNo);


      if (resJson && resJson.id) {
        const urlPageLogin = window.location.pathname;
        // Navigate after setting user context
        sessionStorage.setItem("mobileNumber", JSON.stringify(mobileNo));
        setIsNavigation(true)
        // dispatch(setJwtAuthToken())
        handleLogin(true, resJson.id, mobileNo)
        window.scrollTo({ top: 0, behavior: "smooth" });
        handleLoginSuccess?.(true)
      } else {
        handleLoginSuccess?.(false)
        setError(resJson?.result?.message as string);
        setTimeout(() => setError(null), 30000); // Clear error after 2 seconds
      }
    } catch (err: any) {
      setError(err.message as string);
      setLoading(false)
      setTimeout(() => setError(null), 30000); // Clear error after 2 seconds
    } finally {

    }
  };

  const LoadingSpinner = () => {
    return (
      <>
        <span
          className="spinner-border spinner-border-sm"
          aria-hidden="true"
        ></span>
        <span className="p-2" role="status">
          Please Wait...
        </span>
      </>
    );
  };


  return (
    <div>
      <form
        id="signupForm"
        onSubmit={(e) => {
          e.preventDefault();
          // hanldeLogin(); // Trigger your custom function
        }}
      >
        <div className="input-group mb-0">
          <label className="login_mobile_label">
            Login with your mobile number
            <p className="required" style={{ display: "none" }}>*</p>
          </label>
          <div className="input-group d-flex mb-2">
            <span className="input-group-text fix_91" id="basic-addon1">+91</span>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className={`form-control  mt-0 mb-0 ${showError && mobileNo.length > 0 ? "error-msg" : ""}`}
              placeholder="99999 99999"
              aria-label="Username"
              aria-describedby="basic-addon1"
              style={{ borderLeft: 0 }}
              ref={nameInputRef}
              autoFocus={true}
              onChange={handleChange}
              maxLength={11}
              value={formattedMobileNo}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  hanldeLogin(false);
                }
              }}
            />
          </div>

          <div style={{ height: "25px" }}>
            {showError && mobileNo.length > 0 && (
              <p className="error-message-login" style={{ color: "#666", fontSize: "13px", textAlign: "left" }}>
                10 digits required
              </p>
            )}
            {error && (
              <div className="error-login-page">
                {error.split(".").map((sentence, index) => (
                  <p
                    style={{ color: "#666", fontSize: "13px", textAlign: "left" }}
                    className="error-message-login"
                    key={index}
                  >
                    {sentence.trim()}
                    {index < error.split(".").length - 1 && "."}
                  </p>
                ))}
              </div>
            )}
          </div>



        </div>

        <p style={{ color: "#666", fontSize: "13px", textAlign: "left" }}>
          By signing in, I agree to {" "}
          <Link to='/terms-and-conditions' target="_blank"> T&C  </Link>
          and {" "}
          <Link to='/privacy-policy' target='_blank'>Privacy Policy</Link></p>
        <button
          className="submit-btn"
          type="button"
          onClick={() => hanldeLogin(false)}
          disabled={loading || Boolean(error) || mobileNo.length !== 10}
        >
          {loading ? LoadingSpinner() : "Send OTP"}
        </button>
      </form>
    </div>
  );

};
